var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _this = this;

var createJob = require('./createJob');

var _require = require('./utils/log'),
    log = _require.log;

var getId = require('./utils/getId');

var schedulerCounter = 0;

module.exports = function () {
  var id = getId('Scheduler', schedulerCounter);
  var workers = {};
  var runningWorkers = {};
  var jobQueue = [];
  schedulerCounter += 1;

  var getQueueLen = function getQueueLen() {
    return jobQueue.length;
  };

  var getNumWorkers = function getNumWorkers() {
    return Object.keys(workers).length;
  };

  var dequeue = function dequeue() {
    if (jobQueue.length !== 0) {
      var wIds = Object.keys(workers);

      for (var i = 0; i < wIds.length; i += 1) {
        if (typeof runningWorkers[wIds[i]] === 'undefined') {
          jobQueue[0](workers[wIds[i]]);
          break;
        }
      }
    }
  };

  var queue = function queue(action, payload) {
    return new Promise(function (resolve, reject) {
      var job = createJob({
        action: action,
        payload: payload
      });
      jobQueue.push( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(w) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  jobQueue.shift();
                  runningWorkers[w.id] = job;
                  _context.prev = 2;
                  _context.t0 = resolve;
                  _context.next = 6;
                  return w[action].apply(_this, [].concat(_toConsumableArray(payload), [job.id]));

                case 6:
                  _context.t1 = _context.sent;
                  (0, _context.t0)(_context.t1);
                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t2 = _context["catch"](2);
                  reject(_context.t2);

                case 13:
                  _context.prev = 13;
                  delete runningWorkers[w.id];
                  dequeue();
                  return _context.finish(13);

                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 10, 13, 17]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      log("[".concat(id, "]: Add ").concat(job.id, " to JobQueue"));
      log("[".concat(id, "]: JobQueue length=").concat(jobQueue.length));
      dequeue();
    });
  };

  var addWorker = function addWorker(w) {
    workers[w.id] = w;
    log("[".concat(id, "]: Add ").concat(w.id));
    log("[".concat(id, "]: Number of workers=").concat(getNumWorkers()));
    dequeue();
    return w.id;
  };

  var addJob = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(action) {
      var _len,
          payload,
          _key,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(getNumWorkers() === 0)) {
                _context2.next = 2;
                break;
              }

              throw Error("[".concat(id, "]: You need to have at least one worker before adding jobs"));

            case 2:
              for (_len = _args2.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                payload[_key - 1] = _args2[_key];
              }

              return _context2.abrupt("return", queue(action, payload));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function addJob(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var terminate = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              Object.keys(workers).forEach( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(wid) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return workers[wid].terminate();

                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
              jobQueue = [];

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function terminate() {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    addWorker: addWorker,
    addJob: addJob,
    terminate: terminate,
    getQueueLen: getQueueLen,
    getNumWorkers: getNumWorkers
  };
};